import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskViewModalComponent } from './task-view-modal.component';
import { NgbModalModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ModalFilesModule } from 'src/app/shared/modal-files/modal-files.module';
import { CalendarModule } from 'primeng/calendar';
import { TaskComentsModule } from '../task-coments/task-coments.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { TaskHistoryComponent } from '../task-history/task-history.component';
import { TaskHistoryModule } from '../task-history/task-history.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ChipsModule } from 'primeng/chips';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { TaskFormModule } from '../task-form/task-form.module';
import { NgxSelectModule } from 'ngx-select-ex';
import { ModalSettingsModule } from 'src/app/pages/settings/modal-settings/modal-settings.module';
import { ImageModule } from 'primeng/image';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TimesListComponent } from '../times-list/times-list.component';
import { SharedModule } from 'primeng/api';
@NgModule({
  declarations: [
    TaskViewModalComponent,
    TimesListComponent
  ],
  imports: [
    TaskFormModule,
    CommonModule,
    NgbModalModule,
    TranslateModule,
    ModalFilesModule,
    WidgetModule,
    FormsModule,
    TaskComentsModule,
    CalendarModule,
    TaskHistoryModule,
    InfiniteScrollModule,
    ChipsModule,
    TabViewModule,
    NgbTooltipModule,
    PanelModule,
    NgbPaginationModule,
    SweetAlert2Module,
    PipesModule,
    NgxSelectModule,
    ReactiveFormsModule,
    ModalSettingsModule,
    ImageModule,
    InputMaskModule,
    OverlayPanelModule,
    SharedModule
  ],
  exports: [
    TaskViewModalComponent,
  ]
})
export class TaskViewModalModule { }
